var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":"","loading":_vm.downloading},on:{"click":_vm.onDownload}},[_c('v-icon',[_vm._v(_vm._s(_vm.icons.download))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }